// src/components/Login/Login.js
import React, { useState, useRef, useContext } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthContext } from "../../context/AuthContext";

const Login = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();

  const passwordRef = useRef();
  passwordRef.current = watch("password", "");

  const onSubmit = async (data) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/login`,
        data
      );
      toast.success("Login successful");
      login(res.data.token);
      const lastVisitedPage = localStorage.getItem("lastVisitedPage") || "/";
      navigate(lastVisitedPage);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred";
      toast.error(errorMessage);
    }
  };

  return (
    <div className="min-h-screen py-8 px-4 flex items-center justify-center">
      <ToastContainer />
      <form
        className="bg-gray-100 p-8 rounded-md w-full max-w-md"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex justify-center items-center w-full pb-12">
          <img
            src="https://melo-story.s3.eu-north-1.amazonaws.com/logo.webp"
            alt="Chatbot"
            className="w-auto max-w-64 h-16 sm:h-auto"
            style={{ width: "130px", height: "43px" }}
          />
        </div>

        <h2 className="text-center">Login</h2>
        <div className="mb-4">
          <input
            type="email"
            {...register("email", {
              required: "Email is required",
              pattern: { value: /^\S+@\S+$/i, message: "Invalid email" },
            })}
            className="w-full py-2 px-3 border border-gray-300 rounded outline-none focus:outline-none"
            placeholder="Email"
          />
          {errors.email && (
            <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>
          )}
        </div>
        <div className="mb-6">
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              {...register("password", {
                required: "Password is required",
              })}
              className="w-full py-2 px-3 border border-gray-300 rounded outline-none focus:outline-none"
              placeholder="Password"
            />
            {passwordRef.current && (
              <span
                onClick={togglePasswordVisibility}
                className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
              >
                {showPassword ? (
                  <i className="fa-regular fa-eye text-gray-400"></i>
                ) : (
                  <i className="fa-regular fa-eye-slash text-gray-400"></i>
                )}
              </span>
            )}
          </div>
          {errors.password && (
            <p className="text-red-500 text-sm mt-1">
              {errors.password.message}
            </p>
          )}
        </div>
        <button
          type="submit"
          className="w-full bg-black text-white py-2.5 px-3 rounded"
        >
          Login
        </button>
      </form>
    </div>
  );
};

export default Login;
